import { createStyles } from '@material-ui/core';
export default (theme) => createStyles({
    scrollbar: {
        '&::-webkit-scrollbar': {
            width: 5,
            height: 5
        },
        '&::-webkit-scrollbar-track': {
            boxShadow: 'inset 0 0 5px grey',
            borderRadius: 3
        },
        '&::-webkit-scrollbar-thumb': {
            background: theme.palette.scrollColor,
            borderRadius: 5
        }
    },
    tableScrollbar: {
        '&::-webkit-scrollbar': {
            width: 10,
            height: 10
        },
        '&::-webkit-scrollbar-track': {
            boxShadow: 'inset 0 0 5px grey',
            borderRadius: 5
        },
        '&::-webkit-scrollbar-thumb': {
            background: theme.palette.scrollColor,
            borderRadius: 5
        }
    },
    centeredContent: {
        display: 'flex',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    },
    subText: {
        color: theme.palette.subTextColor,
        fontSize: 12
    },
    externalCodeText: {
        fontSize: 14,
        color: theme.palette.listItem.secondaryText
    }
});
